import { render, staticRenderFns } from "./GameBoyEmulator.vue?vue&type=template&id=07866056"
import script from "./GameBoyEmulator.vue?vue&type=script&lang=ts"
export * from "./GameBoyEmulator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports